export { default } from './FreestarAd';
export type { AdConfig } from './FreestarAd';
